KM3D.scenes.motor = function (T, M, KM) {
  var P = Math.PI, root = new T.Group(), R = 0.42, L = 1.5, XS = [-2.1, -0.7, 0.7, 2.1];
  var PH = [0, P, P, 0], CY = [0, 3 * P, P, 2 * P];
  var i, v, th = [], pst = [], rod = [], glow = [], cam = [], valves = [];
  function add(m, x, y, z) { m.position.set(x, y, z); root.add(m); return m; }

  var shaft = add(KM.cylX(T, 0.22, 0.22, 7.2, M.steel, 28), -0.3, 0, 0);
  [-3.7, -1.4, 0, 1.4, 3.1].forEach(function (x) { add(KM.cylX(T, 0.3, 0.3, 0.3, M.chrome, 28), x, 0, 0); });
  var wsh = new T.Shape(), a, rr;
  for (i = 0; i <= 72; i++) {
    a = i / 72 * P * 2; rr = 0.36 + 0.3 * Math.pow(Math.max(0, -Math.sin(a)), 1.5) + 0.28 * Math.pow(Math.max(0, Math.sin(a)), 6);
    if (i) wsh.lineTo(rr * Math.cos(a), rr * Math.sin(a)); else wsh.moveTo(rr * Math.cos(a), rr * Math.sin(a));
  }
  var wg = new T.ExtrudeGeometry(wsh, { depth: 0.16, bevelEnabled: true, bevelThickness: 0.02, bevelSize: 0.02, bevelSegments: 1, curveSegments: 6 });
  wg.translate(0, 0, -0.08); wg.rotateY(P / 2);
  for (i = 0; i < 4; i++) {
    var g = new T.Group(); g.position.x = XS[i]; g.rotation.x = PH[i]; root.add(g); th.push(g);
    var w1 = new T.Mesh(wg, M.steel); w1.position.x = -0.3; g.add(w1);
    var w2 = new T.Mesh(wg, M.steel); w2.position.x = 0.3; g.add(w2);
    var pin = KM.cylX(T, 0.19, 0.19, 0.5, M.chrome, 24); pin.position.y = R; g.add(pin);
  }

  var lg = new T.CylinderGeometry(0.5, 0.5, 2.6, 40, 1, true, P / 2, P);
  var lg2 = new T.CylinderGeometry(0.58, 0.58, 2.6, 40, 1, true, P / 2, P);
  var lmat = new T.MeshStandardMaterial({ color: 0xc4c8ce, metalness: 1, roughness: 0.38, side: T.DoubleSide });
  var edge = new T.MeshStandardMaterial({ color: 0xb5b9bf, metalness: 1, roughness: 0.4 });
  var grooveG = new T.TorusGeometry(0.46, 0.012, 6, 36), pg = new T.CylinderGeometry(0.46, 0.46, 0.62, 36);
  var rg = new T.BoxGeometry(0.11, 1, 0.15), bigG = new T.CylinderGeometry(0.2, 0.2, 0.46, 24), smG = new T.CylinderGeometry(0.1, 0.1, 0.46, 16);
  bigG.rotateZ(P / 2); smG.rotateZ(P / 2);
  for (i = 0; i < 4; i++) {
    var x = XS[i];
    add(new T.Mesh(lg, lmat), x, 1.95, 0); add(new T.Mesh(lg2, lmat), x, 1.95, 0);
    [-1, 1].forEach(function (s) {
      var e = new T.Mesh(new T.BoxGeometry(0.1, 2.6, 0.04), edge); e.position.set(x + s * 0.54, 1.95, 0); root.add(e);
    });
    var pg0 = new T.Group(); root.add(pg0); pst.push(pg0); pg0.position.x = x;
    var body = new T.Mesh(pg, M.steel); pg0.add(body);
    for (v = 0; v < 3; v++) { var gr = new T.Mesh(grooveG, M.dark); gr.rotation.x = P / 2; gr.position.y = 0.2 - v * 0.065; pg0.add(gr); }
    var cap = new T.Mesh(new T.CylinderGeometry(0.4, 0.4, 0.02, 30), M.chrome); cap.position.y = 0.31; pg0.add(cap);
    pg0.add(new T.Mesh(smG, M.chrome));
    var r0 = new T.Group(); root.add(r0); r0.position.x = x; rod.push(r0);
    var rb = new T.Mesh(rg, M.steel); r0.add(rb); r0.userData.b = rb;
    var big = new T.Mesh(bigG, M.steel); r0.add(big); r0.userData.big = big;
    var sm = new T.Mesh(smG, M.steel); r0.add(sm); r0.userData.sm = sm;
    var gl = new T.Mesh(new T.CylinderGeometry(0.47, 0.47, 1, 32), M.glow.clone()); gl.position.set(x, 3, 0); root.add(gl); glow.push(gl);
    var gl2 = new T.Mesh(new T.SphereGeometry(0.2, 12, 10), M.glow.clone()); gl2.position.set(x, 3.2, 0); root.add(gl2); gl.userData.core = gl2; root.add(gl2);
    [-0.2, 0.2].forEach(function (zz, k) {
      var vg = new T.Group(); vg.position.set(x + (k ? 0.18 : -0.18), 3.3, zz); root.add(vg);
      var st = new T.Mesh(new T.CylinderGeometry(0.03, 0.03, 0.85, 8), M.chrome); st.position.y = 0.42; vg.add(st);
      var hd = new T.Mesh(new T.CylinderGeometry(0.16, 0.03, 0.06, 18), M.steel); hd.position.y = 0.0; vg.add(hd);
      var sp = KM.spring(T, 0.07, 0.4, 6, 0.012, M.dark); sp.position.y = 0.3; vg.add(sp); vg.userData.sp = sp;
      valves.push(vg); vg.userData.base = 3.3; vg.userData.ph = i;
    });
  }

  [-0.5, 0.5].forEach(function (z, k) {
    var cs = new T.Group(); cs.position.set(0, 3.95, z); root.add(cs); cam.push(cs);
    cs.add(KM.cylX(T, 0.09, 0.09, 6.0, M.steel, 14));
    XS.forEach(function (x, ci) {
      [-0.2, 0.2].forEach(function (d, kk) {
        var lb = KM.cylX(T, 0.17, 0.17, 0.16, M.steel, 20); lb.scale.set(1, 1, 1.0); lb.position.set(x + d, 0.07, 0); cs.add(lb);
      });
      var jn = KM.cylX(T, 0.13, 0.13, 0.22, M.chrome, 16); jn.position.set(x + 0.55, 0, 0); cs.add(jn);
    });
    var sp2 = new T.Mesh(KM.gear(T, { n: 34, ro: 0.5, ri: 0.44, d: 0.1, hole: 0.06 }), M.steel); sp2.rotation.y = P / 2; sp2.position.x = 3.3; cs.add(sp2);
    cs.userData.sp = sp2;
  });
  var cks = new T.Group(); var cksm = new T.Mesh(KM.gear(T, { n: 17, ro: 0.4, ri: 0.34, d: 0.1, hole: 0.05 }), M.steel); cksm.rotation.y = P / 2; cks.add(cksm); add(cks, 3.3, 0, 0);

  var fw = new T.Group(); fw.position.x = -4.1; root.add(fw);
  var fg = new T.Mesh(KM.gear(T, { n: 96, ro: 1.28, ri: 1.2, d: 0.22 }), M.dark); fg.rotation.y = P / 2; fw.add(fg);
  var fd = KM.cylX(T, 1.2, 1.2, 0.16, M.steel, 64); fd.position.x = 0.05; fw.add(fd);
  var fh = KM.cylX(T, 0.42, 0.42, 0.34, M.chrome, 40); fh.position.x = 0.2; fw.add(fh);
  var fr = new T.Mesh(new T.TorusGeometry(0.8, 0.03, 8, 64), M.chrome); fr.rotation.y = P / 2; fr.position.x = 0.14; fw.add(fr);
  add(KM.cylX(T, 0.13, 0.13, 0.8, M.chrome, 20), -4.8, 0, 0);

  var pts = [[-0.38, 0], [0.02, 0.4], [1.9, 0.7], [3.6, 0.95], [4.2, 0.82], [4.4, 0.5], [4.4, -0.5], [4.2, -0.82], [3.6, -0.95], [1.9, -0.7], [-0.02, -0.4]]
    .map(function (p) { return new T.Vector3(3.3, p[0] + 0, p[1]); });
  var curve = new T.CatmullRomCurve3(pts, true, 'catmullrom', 0.3);
  var N = 96, links = new T.InstancedMesh(new T.BoxGeometry(0.13, 0.07, 0.05), M.black, N), dm = new T.Object3D();
  root.add(links);
  var posV = new T.Vector3(), tanV = new T.Vector3();
  add(KM.shadow(T, 12, 5, -1.36, 0.7), -0.3, -1.36, 0);

  var TH0 = 3.25 * P;
  function pulse(u) { return u < 0 || u > 1 ? 0 : Math.pow(1 - u, 1.4) * Math.min(1, u * 14); }
  function update(t) {
    var th0 = TH0 + t * 3.9, i;
    for (i = 0; i < 4; i++) {
      var ang = th0 + PH[i], cy = R * Math.cos(ang), cz = R * Math.sin(ang);
      th[i].rotation.x = ang;
      var yp = cy + Math.sqrt(L * L - cz * cz);
      pst[i].position.y = yp;
      var dy = yp - cy, dz = -cz, len = Math.sqrt(dy * dy + dz * dz), al = Math.atan2(dz, dy), r0 = rod[i];
      r0.userData.b.scale.y = len; r0.userData.b.position.set(0, (cy + yp) / 2, cz / 2); r0.userData.b.rotation.x = al;
      r0.userData.big.position.set(0, cy, cz); r0.userData.sm.position.set(0, yp, 0);
      var cyc = ((th0 + CY[i]) % (4 * P) + 4 * P) % (4 * P), pw = pulse(cyc / P);
      var top = 3.3, bot = yp + 0.31, h = Math.max(0.05, top - bot);
      glow[i].scale.y = h; glow[i].position.y = bot + h / 2; glow[i].material.opacity = pw * 0.9;
      glow[i].userData.core.material.opacity = pw; glow[i].userData.core.position.y = top - 0.1;
    }
    cam.forEach(function (c) { c.rotation.x = th0 / 2; });
    cks.rotation.x = th0; fw.rotation.x = th0;
    valves.forEach(function (vg) {
      var k = Math.max(0, -Math.cos(th0 / 2 * 1 + vg.userData.ph * P / 1.5)); k = Math.pow(k, 3) * 0.13;
      vg.position.y = vg.userData.base - k; vg.userData.sp.scale.y = 1 - k * 0.8;
    });
    var tt = (t * 3.9 / (P * 2)) * 0.55;
    for (i = 0; i < N; i++) {
      var u = (i / N + tt) % 1;
      curve.getPointAt(u, posV); curve.getTangentAt(u, tanV);
      dm.position.copy(posV); dm.quaternion.setFromUnitVectors(new T.Vector3(0, 1, 0), tanV.clone().normalize());
      dm.updateMatrix(); links.setMatrixAt(i, dm.matrix);
    }
    links.instanceMatrix.needsUpdate = true;
  }
  root.position.set(0.3, -1.6, 0);
  return { root: root, update: update, pose: 0, cam: { fov: 30, p: [6.8, 3.4, 10], l: [0.3, 0.5, 0] } };
};